import {getTypeContrat} from '../../common/utils/contrat';

export type TypeContrat =
  | 'retraite'
  | 'scolaire'
  | 'rcvp'
  | 'voyage'
  | 'auto'
  | 'rapatriement'
  | 'noType';

export class Contrat {
  id: string;
  type: TypeContrat;
  title: string;
  subTitle: string;
  is_ending: boolean;
  isAvenant: boolean;
  policyNumber: false | string;

  constructor(
    id: string,
    title: string,
    subTitle: string,
    is_ending: boolean,
    isAvenant: boolean,
    policyNumber: false | string,
  ) {
    this.type = getTypeContrat(title);
    this.title = title;
    this.id = id;
    this.subTitle = subTitle;
    this.is_ending = is_ending;
    this.isAvenant = isAvenant;
    this.policyNumber = policyNumber;
  }
}
